import router from "./router";
import store from "./store";
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth) || to.path === '/my') {
    const openid = localStorage.getItem("openid");
    const accessToken = localStorage.getItem('accessToken')
    if (openid && accessToken) {
      if (!store.state.accessToken) {
        store.dispatch('GetUserInfo', openid)
        next()
      }
      next()
    } else {
      if (to.path === '/my') {
        next()
      } else {
        next("/login");
      }
      
    }
  } else {
    next();
  }
});